import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import classnames from 'classnames'
import { withRouter, NavLink } from 'react-router-dom'

import { utcToLocalDetailedDate } from '../../../helpers/timeHelper'
import { StatusPill } from '../../common/statusPill'
import { User } from '../../../core/types'

export const urlCheck = (location) => {
  const { pathname } = location
  const lastPathSegment = pathname.split('/').pop()
  return 'create-ticket' === lastPathSegment
}

export interface Props {
  user: User
  location: Location
  /** True while the on-demand tickets request is in flight. */
  isLoading?: boolean
}

export class UserBannerZendeskPanel extends Component<Props> {
  static displayName = 'UserBannerZendeskPanel'

  render() {
    const { user, location, isLoading } = this.props
    const { tickets } = user
    const requesterId = !isEmpty(tickets) && tickets[0].requesterExternalId

    return (
      <div className="user-banner__zendesk-panel">
        <div className="user-banner__ticket-section">
          {isLoading ? (
            <p className="user-banner__zendesk-ticket-default">
              Loading Zendesk tickets...
            </p>
          ) : tickets && tickets.length > 0 ? (
            tickets.map((ticket) => {
              const unread = ticket.status === 'new' || ticket.status === 'open'
              return (
                <div
                  key={ticket.id}
                  className="user-banner__zendesk-ticket-row"
                >
                  <StatusPill isSmall status={ticket.status} />
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_ZENDESK_URL}/agent/tickets/${ticket.id}`}
                    className={classnames(
                      'user-banner__zendesk-ticket-subject',
                      {
                        'user-banner__zendesk-ticket-subject--unread': unread,
                      }
                    )}
                  >
                    {ticket.subject}
                  </a>
                  <p className="user-banner__zendesk-ticket-date">
                    {utcToLocalDetailedDate(ticket.updatedAt)}
                  </p>
                </div>
              )
            })
          ) : (
            <p className="user-banner__zendesk-ticket-default">
              No Zendesk tickets
            </p>
          )}
        </div>
        <div className="user-banner__zendesk-buttons">
          <NavLink
            to={`/users/${user.id}/create-ticket`}
            className={classnames(
              'button button--primary-round button--full-width',
              {
                'disabled-link button--disabled-link': urlCheck(location),
              }
            )}
          >
            Create a new ticket
          </NavLink>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.REACT_APP_ZENDESK_URL}/agent/users/${requesterId}/requested_tickets`}
            className={classnames(
              'button button--secondary-round button--full-width',
              {
                'disabled-link button--disabled-link': isEmpty(requesterId),
              }
            )}
          >
            View all tickets
          </a>
        </div>
      </div>
    )
  }
}

export default withRouter(UserBannerZendeskPanel)
